import { render, staticRenderFns } from "./signout-oidc.vue?vue&type=template&id=28a88c52"
import script from "./signout-oidc.vue?vue&type=script&lang=ts"
export * from "./signout-oidc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports